import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

function Rechner() {
  const [anrufe, setAnrufe] = useState(20);
  const [dauer, setDauer] = useState(4);

  const min = anrufe * dauer * 22;
  const fp = min <= 1000 ? 99 : min <= 3000 ? 199 : 299;
  const ma = Math.round((min / 60) * 35);
  const sp = Math.max(0, ma - fp);

  return (
    <div className="rechner-card">
      <div className="rc-row">
        <div className="rc-top">
          <span className="rc-label">Anrufe pro Tag</span>
          <span className="rc-value">{anrufe}</span>
        </div>
        <input type="range" min="5" max="200" value={anrufe} onChange={e => setAnrufe(+e.target.value)} />
      </div>
      <div className="rc-row">
        <div className="rc-top">
          <span className="rc-label">Durchschnittliche Anrufdauer</span>
          <span className="rc-value">{dauer} Min</span>
        </div>
        <input type="range" min="1" max="15" value={dauer} onChange={e => setDauer(+e.target.value)} />
      </div>
      <div className="rc-results">
        <div className="rr">
          <div className="rr-lbl">FrontUp / Monat</div>
          <div className="rr-val">{fp} €</div>
        </div>
        <div className="rr">
          <div className="rr-lbl">Mitarbeiter / Monat</div>
          <div className="rr-val">{ma.toLocaleString('de')} €</div>
        </div>
        <div className="rr hi">
          <div className="rr-lbl">Du sparst</div>
          <div className="rr-val">{sp.toLocaleString('de')} €</div>
        </div>
      </div>
      <p className="rc-note">Basierend auf 22 Arbeitstagen/Monat und durchschnittlich 35 €/Stunde inkl. Lohnnebenkosten.</p>
    </div>
  );
}

function PreisePage() {
  const navigate = useNavigate();

  const goDemo = () => navigate('/', { state: { scrollTo: 'demo' } });
  const goRegister = () => navigate('/register');
  const goContact = () => window.open('https://wa.me/491791548222', '_blank');

  return (
    <>
      <Nav />

      <div className="preise-hero">
        <div className="preise-hero-inner">
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:12}}>Preise</div>
          <h1 style={{fontSize:'clamp(44px,5.5vw,68px)',fontWeight:800,letterSpacing:'-2.5px',lineHeight:1.04,color:'#111',marginBottom:12}}>Einfache, faire Preise.</h1>
          <p style={{fontSize:18,color:'#888',maxWidth:480}}>Keine Mindestlaufzeit. Monatlich kündbar. Keine versteckten Kosten.</p>

          <div className="preise-grid">
            {/* STARTER */}
            <div className="pk">
              <div className="pk-tier">Starter</div>
              <div className="pk-price">99<span style={{fontSize:20,letterSpacing:0}}>€</span></div>
              <div className="pk-period">pro Monat <span style={{fontSize:11,fontWeight:400,color:'#aaa',marginLeft:6}}>Setup 499 € einmalig</span></div>
              <div className="pk-desc">Für kleine Unternehmen mit bis zu 20 Anrufen täglich.</div>
              <ul className="pk-feats">
                <li className="pk-feat">Bis zu 1.000 Minuten/Monat</li>
                <li className="pk-feat">1 KI-Assistent + 1 Nummer</li>
                <li className="pk-feat">Automatische Anrufannahme</li>
                <li className="pk-feat">E-Mail Transkription</li>
                <li className="pk-feat">Terminbuchung</li>
              </ul>
              <button className="pk-btn" onClick={goDemo}>Kostenlos testen</button>
            </div>

            {/* PROFESSIONAL */}
            <div className="pk featured">
              <div className="pk-badge">Beliebteste Wahl</div>
              <div className="pk-tier">Team</div>
              <div className="pk-price">299<span style={{fontSize:20,letterSpacing:0}}>€</span></div>
              <div className="pk-period">pro Monat <span style={{fontSize:11,fontWeight:400,color:'rgba(255,255,255,0.5)',marginLeft:6}}>Setup 499 € einmalig</span></div>
              <div className="pk-desc">Für wachsende Unternehmen mit mehr Anrufvolumen.</div>
              <ul className="pk-feats">
                <li className="pk-feat">Bis zu 3.000 Minuten/Monat</li>
                <li className="pk-feat">3 KI-Assistenten + 3 Nummern</li>
                <li className="pk-feat">CRM-Integration</li>
                <li className="pk-feat">Anruf-Weiterleitung</li>
                <li className="pk-feat">Echtzeit-Dashboard</li>
                <li className="pk-feat">Prioritäts-Support</li>
              </ul>
              <button className="pk-btn" onClick={goDemo}>Kostenlos testen</button>
            </div>

            {/* ENTERPRISE */}
            <div className="pk">
              <div className="pk-tier">Enterprise</div>
              <div className="pk-price" style={{fontSize:32,letterSpacing:'-1px',marginTop:6}}>Individuell</div>
              <div className="pk-period">auf Anfrage <span style={{fontSize:11,fontWeight:400,color:'#aaa',marginLeft:6}}>Setup 499 € einmalig</span></div>
              <div className="pk-desc">Für große Unternehmen mit individuellem Bedarf.</div>
              <ul className="pk-feats">
                <li className="pk-feat">Unbegrenzte Minuten</li>
                <li className="pk-feat">Unbegrenzte Assistenten</li>
                <li className="pk-feat">Individuelle Integrationen</li>
                <li className="pk-feat">Dedicated Account Manager</li>
                <li className="pk-feat">SLA & Uptime-Garantie</li>
              </ul>
              <button className="pk-btn" onClick={goContact}>Kontakt aufnehmen</button>
            </div>
          </div>
        </div>
      </div>

      {/* RECHNER */}
      <section style={{background:'#f7f7f7',padding:'88px 40px'}}>
        <div style={{textAlign:'center',marginBottom:48}}>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:12}}>Kostenrechner</div>
          <h2 style={{fontSize:'clamp(32px,4vw,48px)',fontWeight:800,letterSpacing:'-2px',color:'#111',marginBottom:10}}>Einsparpotenzial mit FrontUp.</h2>
          <p style={{fontSize:16,color:'#888'}}>Berechne wie viel du im Vergleich zu einer menschlichen Telefonkraft sparst.</p>
        </div>
        <Rechner />
        <div style={{textAlign:'center',marginTop:24}}>
          <button className="btn-hero-p" onClick={goDemo}>Jetzt kostenlos testen</button>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="cta-inner">
          <h2 className="cta-h">Bereit loszulegen?</h2>
          <p className="cta-p">Starte heute. In 5 Minuten eingerichtet.</p>
          <button className="btn-cta" onClick={goDemo}>Jetzt kostenlos testen</button>
        </div>
      </section>

      <Footer simple />
    </>
  );
}

export default PreisePage;
